import { WHEN_BLOCK } from 'constants/MeshbotConstant';

import { getFieldByName } from './getFieldByName';
import { getItemById } from './getItemById';
import { getRestoredUserFieldValue } from './getRestoredUserFieldValue';

/**
 * Reconstructs capabilityDynamicFields from a saved isUserLockOperation when-block (edit/restore path, no blockMeta;
 * shared by all value types of this method). Reads the `state` and `user` fields. PIN-key existence is resolved
 * HERE, once, at restore time (see getRestoredUserFieldValue): an orphan key is normalized to null so downstream
 * validation and rendering are O(1) reads with no further store lookups.
 * @param {Object} block - when-block ({ fields: [item, state, user] })
 * @param {Array} items - controller items
 * @param {string} deviceId - device id
 * @returns {Object} { stateFieldValue, userFieldValue, userCodesItemId }
 */
export const getUserLockOperationDynamicFields = (block, items, deviceId) => {
    const stateField = getFieldByName(block?.fields, WHEN_BLOCK.STATE);
    const userField = getFieldByName(block?.fields, WHEN_BLOCK.USER);
    const itemFieldValue = getFieldByName(block?.fields, WHEN_BLOCK.ITEM)?.value;
    const valueType = getItemById(items, itemFieldValue)?.valueType;
    const stateFieldValue = stateField?.value;
    const userCodesItemId = userField?.optionItemValue?.itemId;

    return {
        stateFieldValue,
        userFieldValue: getRestoredUserFieldValue(
            valueType,
            stateFieldValue,
            userField?.value,
            userCodesItemId,
            items,
            deviceId,
        ),
        userCodesItemId,
    };
};
